import { Injectable } from "@angular/core";
import { AbstractControl, ValidatorFn } from "@angular/forms";

@Injectable()
export class NameValidator {
  constructor() {}
  noNumeric(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        return null; 
      }
      
      const hasNumeric = /[0-9]/.test(control.value);
      return hasNumeric ? { 'hasNumeric': true } : null;
    };
  }
}
